/***********
 * 实验记录
 **************/
const columns = [{
  title: "姓名",
  dataIndex: "user_name",
  key: "user_name"
}, {
  title: "实验名称",
  dataIndex: "record_name",
  key: "record_name"
}, {
  title: "实验结果",
  dataIndex: "record_result",
  key: "record_result"
}, {
  title: "实验开始时间",
  dataIndex: "start_time",
  key: "start_time"
}, {
  title: "实验结束时间",
  dataIndex: "end_time",
  key: "end_time"
}, {
  title: "实验用时",
  dataIndex: "use_time",
  key: "use_time"
}, {
  title: "实验成绩",
  dataIndex: "score",
  key: "score"
} // {
//   title: "实验报告",
//   dataIndex: "action",
//   key: "action",
//   width: 100,
//   scopedSlots: { customRender: "action" },
// },
];
export default {
  props: {
    laboratoryItemDetail: {
      type: Object
    },
    moudleName: {
      type: String
    },
    recordOrginList: {
      type: Array
    }
  },

  data() {
    return {
      columns,
      form: {
        record_name: "",
        pystatus: "",
        user_name: "",
        // datevalue: "",
        shenqipy: "",
        project: ""
      },
      recordList: [],
      vr_id: ""
    };
  },

  watch: {
    laboratoryItemDetail: {
      handler(newval, oldval) {
        if (newval) {
          this.vr_id = newval.id;
        }
      },

      deep: true,
      immediate: true
    },
    recordOrginList: {
      handler(newval, oldval) {
        if (newval && Array.isArray(newval) && newval.length > 0) {
          this.recordList = newval;
        }
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    async getRecordList() {
      const data = await this.$get("/34-getVRRecordPageByParam/union-vr", {
        record_name: this.form.record_name,
        user_name: this.form.user_name,
        vr_id: this.vr_id
      });
      this.recordList = data.content;
    },

    hrefdetail(text, record) {
      window.open(record.file_url, "_blank");
    },

    //开始查询
    async onSubmit() {
      this.getRecordList();
    }

  }
};